export const ROBOTS_HEADER = 'X-Robots-Tag';
export const ROBOTS_NOINDEX_VALUE = 'noindex, nofollow';
export const COM_CONTENT_NO_INDEX_FLAG = 'comContentNoIndex';
